export default __webpack_public_path__ + "static/media/portal.0cc48bb8.png";